import User from './user'
import Error from './error'
import store from '../root.store'
import Settings from './settings'
import Applicant from './applicant'
import Classifiers from './classifiers'
import Authentication from './authentication'

/**
* Try if we can even use cookies/storage
* or redirect to separate storageless app
* note that /cookieless.html is not a real file
* but defined in vue.config.js as a separate entry
* */

try {
    sessionStorage.setItem('canUseStorage', 'CanBeUsed')
    document.cookie = 'canUseCookies=true; max-age=1'
    sessionStorage.removeItem('canUseStorage')
} catch (e) {
    location.href = '/ekpid/cookieless.html'
}

export const authenticationStore = new Authentication({
    store,
    name: 'Authentication'
})

export const classifiersStore = new Classifiers({
    store,
    name: 'Classifiers'
})

export const settingsStore = new Settings({
    store,
    name: 'Settings'
})

export const userStore = new User({
    store,
    name: 'User'
})

export const applicantStore = new Applicant({
    store,
    name: 'Applicant'
})

export const errorStore = new Error({
    store,
    name: 'ErrorModule'
})
